import { Injectable } from '@angular/core';
import { first, Subscription } from 'rxjs';
import { SignalUser } from '../../models/SignalUser/SignalUser';
import { SignalUserAPIService } from '../API/Signal-UserAPI.service';
import { NotificationsToastService } from '../Notifications-Toast.service';
import { AzureBotService } from "../../../ui/organisms/azure-bot/services/AzureBot.service";
import { environment } from "src/environments/environment";
import { LocalStorageService } from '../LocalStorage.service';
@Injectable({
  providedIn: 'root'
})

export class SignalUserService {
 
  subscription_AddSignalUser: Subscription;
  subscription_DeleteSignalUser: Subscription;

  constructor(private signalUserService: SignalUserAPIService, 
    private notificationsToastService: NotificationsToastService,
    private AzureBotService: AzureBotService,
    private localStorageService: LocalStorageService,
  ) {
}

ngOnDestroy() {
   if (this.subscription_AddSignalUser)
    this.subscription_AddSignalUser.unsubscribe();
}


//subscribe al usuari de manera general a signal desde el login
SubscribeGeneralSignalUserService(SignalUser: SignalUser) {
  SignalUser.Identifier = "General";
  //Subscribe to SignalClient
  this.subscription_AddSignalUser = this.AddSignalUser(SignalUser)
  .pipe(first()).subscribe({
    next: (data) => {
    },
    error: (error) => {
      // TODO marca para complete despues
      console.error('Error al suscribir usuario general de signal', error);
    }
  })
}

SubscribeChatBotSignalUserService(SignalUser: SignalUser) {
  var user = this.localStorageService.getUser();
  SignalUser.Identifier = "ChatBot-"+user;
  this.AzureBotService.signalIdentifier = SignalUser.Identifier;
  this.subscription_AddSignalUser = this.AddSignalUser(SignalUser)
  .pipe(first()).subscribe({
    next: (data) => {
      if(!environment.production) console.log("SignalUserService: ", data);
    },
    error: (error) => {
      // TODO marca para complete despues
      console.error('Error al suscribir usuario ChatBot de signal', error);
    }
  })
}

SubscribeIdentifierSignalUserService(SignalUser: SignalUser) {
  //Subscribe to SignalClient
  this.subscription_AddSignalUser = this.AddSignalUser(SignalUser)
  .pipe(first()).subscribe({
    next: (data) => {
      this.notificationsToastService.showRealTime(
        "Activando Monitoreo con Satelites en Tiempo Real",
        "LiveUpdate Activado"
      );
    },
    error: (error) => {
      // TODO marca para complete despues
      console.error('Error al suscribir un activo de signal', error);
    }
  })
}

UnsubscribeSignalUserService(){
//Subscribe to SignalClient
  this.subscription_DeleteSignalUser = this.DeleteByUser()
  .subscribe({
    next: (data) => {
    },
    error: (error) => {
      // TODO marca para complete despues
      console.error('Error al desuscribir usuario de signal', error);
    }
  });
}

UnsubscribeSignalUserIdentifierService(identifier : string){
  //Subscribe to SignalClient
  this.subscription_DeleteSignalUser = this.DeleteByUserIdentifier(identifier)
  .subscribe({
    next: (data) => {
      this.notificationsToastService.showDisconnectRealTime(
        "Desactivado monitoreo en tiempo real",
        "LiveUpdate Desactivado"
      )
    },
    error: (error) => {
      // TODO marca para complete despues
      console.error('Error al desuscribir un activo de signal', error);
    }
  });
}

private AddSignalUser(signalUser: SignalUser): any {
  return this.signalUserService.AddSignalUser(signalUser);
}

DeleteByUser() {
  return this.signalUserService.DeleteByUser();
}
private DeleteByUserIdentifier(identifier: string) {
  return this.signalUserService.DeleteByUserIdentifier(identifier);
}
}
